import React from 'react';
import FooterComponent from '../../components/Footer';

const FooterContainer= (props)=>{
    return <FooterComponent {...props} />;
};

export default FooterContainer;